import { selectLastUpdate, selectLoadingOrInitial, } from "@single-js/common/util/loading-state-machine";
import { selectLicenseLastUpdate, selectLicenseLoading, } from "data/selectors/license";
import { selectPipelinesLastUpdate, selectPipelinesLoading, } from "data/selectors/pipelines";
import { selectSchemaSummaryLastUpdate, selectSchemaSummaryLoading, } from "data/selectors/schema";
import { selectDerivedNodesLastUpdate, selectDerivedNodesLoading, } from "data/selectors/topology";
import _ from "lodash";
import { createSelector } from "reselect";
export const selectClusterMetadataLoading = (s) => selectLoadingOrInitial(s.clusterMetadata.clusterStatistics);
const selectClusterMetadataLastUpdate = (s) => selectLastUpdate(s.clusterMetadata.clusterStatistics);
// We return `true` if ANY of the stores that ANY of the cards
// depend on are in the loading state.
export const isDashboardLoading = createSelector(selectDerivedNodesLoading, selectClusterMetadataLoading, selectPipelinesLoading, selectSchemaSummaryLoading, selectLicenseLoading, (nodesLoading, clusterMetadataLoading, pipelinesLoading, schemaSummaryLoading, licenseLoading) => {
    return (nodesLoading ||
        clusterMetadataLoading ||
        pipelinesLoading ||
        schemaSummaryLoading ||
        licenseLoading);
});
// We look at all of the stores that all of the cards depend on and
// return the date that is more recent.
export const lastDashboardUpdate = createSelector(selectDerivedNodesLastUpdate, selectClusterMetadataLastUpdate, selectPipelinesLastUpdate, selectSchemaSummaryLastUpdate, selectLicenseLastUpdate, (nodesLastUpdate, clusterMetadataLastUpdate, pipelinesLastUpdate, schemaSummaryLastUpdate, licenseLastUpdate) => {
    return _.max([
        nodesLastUpdate,
        clusterMetadataLastUpdate,
        pipelinesLastUpdate,
        schemaSummaryLastUpdate,
        licenseLastUpdate,
    ]);
});
